module.exports = __webpack_public_path__ + "img/5f_r_kandagawa@2x.43d26464.png";